import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { $Elements, BrowserEvents, Classes, Elements } from '../global/constants';
import { ajax } from '../global/helpers';

;(function($) {

	// ---------- Handle Form ----------

	function handleForm(form, params) {

		const formContent = form.find('.form-content');
		const formDone = form.find('.form-done');
		const formSuccess = formDone.find('.success');
		const formError = formDone.find('.error');
		const date = form.find('[name=date]');
		const datePicker = form.find('.date-picker');
		const button = form.find('button[type=submit]');

		date.datepicker({
			container: datePicker,
			inline:    true,
			language:  'fr-FR',
			format:    'dd-mm-yyyy',
			filter:    (date, view) => {

				if(view === 'day' && date.getDay() === 0) {
					return false;
				}

				if(view === 'day' && params.saturdays !== '1' && date.getDay() === 6) {
					return false;
				}

				return true;
			}
		});

		date.on('click', () => datePicker.addClass(Classes.active));
		date.on('pick.datepicker', () => datePicker.removeClass(Classes.active));

		form.on('submit', e => e.preventDefault());

		form.parsley().on('form:submit', async function() {

			button.attr('disabled', true);
			Elements.LoadingBar.classList.add(Classes.loading);

			const formData = new FormData(form[0]);
			formData.append('action', params.action);
			formData.append('nonce', params.nonce);

			try {

				const response = await ajax({
					url:         params.url,
					type:        'POST',
					dataType:    'json',
					data:        formData,
					processData: false,
					contentType: false,
				});

				formSuccess.removeClass(Classes.hidden);
			}
			catch(e) {
				formError.removeClass(Classes.hidden);
			}

			button.attr('disabled', false);
			Elements.LoadingBar.classList.remove(Classes.loading);
			formContent.addClass(Classes.hidden);
			formDone.removeClass(Classes.hidden);

			return false;
		});
	}

	$Elements.document.ready(function() {

		// ---------- Reservation Form ----------

		if(typeof reservation_form_params !== 'undefined') {

			$('#reservation-modal').on('show.bs.modal', function(e) {
				const self = $(this);

				self.find('.form-content').removeClass('d-none');
				self.find('.form-done, .form-done .success, .form-done .error').addClass(Classes.hidden);

				disableBodyScroll(this);
			});

			$('#reservation-modal').on('hidden.bs.modal', function(e) {
				enableBodyScroll(this);
			});

			$('form.reservation-form').each(function() {
				handleForm($(this), reservation_form_params);
			});
		}

	});

	$Elements.document.on(BrowserEvents.page.enter, function() {

		// ---------- Store Locator Form ----------

		if(typeof store_locator_form_params !== 'undefined') {

			$('form.store-locator-form').each(function() {
				handleForm($(this), store_locator_form_params);
			});
		}

		$('a[href="#reservation-modal"]').click((e) => {
			e.preventDefault();
			$('#reservation-modal').modal();
		});
	});

}(jQuery));
